import store from '@/store'
import { mpx } from '@didi/es-mpx-creator'
import { getStorage } from '@/utils/storage'
import { getEnvInfo } from '@didi/webx-js'
import { getCouponListApi } from '@/api/coupon'
import { handleCouponData } from '@/utils/coupon'
import { sendEvent } from '@/utils'
import { accPacStatusUpdateApi } from '@/api/package'

const getCouponData = async ({ commit }, options = {}) => {
  try {
    const { xpsid = '', dchn = '', xenv = '' } = store?.state?.common?.xpsmInfo
    const envInfo = await getEnvInfo()
    // 风控参数
    const envParams = {
      ...envInfo,
      isOpenWeb: false,
      isHitButton: true,
      newTicket: getStorage?.('userInfo')?.token || '',
    }
    const { data, code, success } = await getCouponListApi({
      dchn,
      xenv,
      xpsid,
      env: envParams,
      ...options,
    })
    if (!success) return
    if (Number(code) !== 0) return
    data.banner_config?.length && store.commit('coupon.setTrainBannerData', data.banner_config)
    commit('setCouponData', handleCouponData(data))
  } catch (e) {
    console.log('请求券列表失败了! 主公！')
  }
}

export const accPacStatusUpdate = () => {
  const params = {
    status: 1
  }
  accPacStatusUpdateApi(params).then(res =>{
    const { code, success } = res || {}
    if(success && +code === 0) {
      mpx.showToast({
        title: '分享成功', //提示的内容,
        icon: 'success', //图标,
        duration: 2000, //延迟时间,
      });
      sendEvent('updateCoupon')
    }
  })
}

export default { getCouponData, accPacStatusUpdate }
